import layerColour from '../enums/layerColourEnum'

const getLayerColour = (position) => {
    return layerColour[position]
  };

export default getLayerColour